import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Feeds } from 'src/app/models/feeds';
import { CommonService } from 'src/app/service/common.service';
import { HttpClient } from '@angular/common/http';
import { MessageService } from 'src/app/service/messageService';
import { WebService } from 'src/app/service/web.service';

@Component({
  selector: 'app-feeds',
  templateUrl: './feeds.component.html',
  styleUrls: ['./feeds.component.scss']
})
export class FeedsComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private route: Router,
    public commonService : CommonService,
    private activatedRoute: ActivatedRoute,
    private webService : WebService,
    private msgService: MessageService,
    private http: HttpClient
  ) {
    this.feedsForm = this.formBuilder.group({
      categorytype: [""],
      domain: [""],
      descriptionval: [""],
      contentDetailsval:[""],
      feedlink: [""],
      tags: [""]
    });
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(
      (params: Params) => (this.feedId = params["id"])
    );
    // this.tagList.push(...this.tagListOrg);
    if(this.commonService.validateTextId(this.feedId)) {
      this.getFeedsList(this.feedId)
      // this.setFeedDetails();
    }
    this.getCategoryTypes();
    this.getDomainTypes();
    this.getTagList();

  }

  feedsForm: FormGroup;
  selectedCategory: any;
  selectedDomain: any;
  description: any;
  contentDetails:any;
  feedLink: any;
  selectedTagIds: any[] = [];

  feeds: Feeds = new Feeds();
  feedId: any;
  
  // categoryTypes: any[] = [{name:'Technical', identity: '1'}, {name:'Industry News', identity: '2'}];
  // domainTypes: any[] = [{name:'Infra', identity: '1'}, {name:'DevOps', identity: '2'}, {name:'Cloud', identity: '3'}, {name:'ADM', identity: '4'}, {name:'Containers', identity: '5'}, {name:'Others', identity: '6'}];
  tagList: any[] = [];
  // tagListOrg: any[] = [{name:'Angular', identity: '1'}, {name:'Java', identity: '2'}, {name:'Spring Boot', identity: '3'}, {name:'Typescript', identity: '4'}, {name:'AWS', identity: '5'}, {name:'Lambda', identity: '6'}, {name:'Node', identity: '7'}];

  categoryTypes: any[] = [];
  tagListOrg: any[] = [];
  domainTypes: any[] = [];
  getCategoryTypes(){
    this.webService.getOptionListByGroup("Feed-Category").subscribe((data:any)=>{
      this.categoryTypes =  data;
    })    
  }

  
  getDomainTypes(){
    this.webService.getOptionListByGroup("Feed-Domain").subscribe((data:any)=>{
      this.domainTypes =  data;
    })    
  }
  
  
  getTagList(){
    this.webService.getOptionListByGroup("Tags").subscribe((data:any)=>{
      this.tagListOrg= data;
      this.tagList.push(...this.tagListOrg);

    })    
  }
  


  categories = [
    {id: 1, name: 'Laravel'},
    {id: 2, name: 'Codeigniter'},
    {id: 3, name: 'React'},
    {id: 4, name: 'PHP'},
    {id: 5, name: 'Angular'},
    {id: 6, name: 'Vue'},
    {id: 7, name: 'JQuery', disabled: true},
    {id: 8, name: 'Javascript'},
  ];
    
  selected = [
    {id: 5, name: 'Angular'},
    {id: 6, name: 'Vue'}
  ];


  getFeedsListCall(feedId:any) {
  
    return this.http.get("https://gjlyzzqd34ns2kozsmfkjbdh4q0ouooi.lambda-url.us-west-1.on.aws/?param1="+feedId);
  }

  getFeedsList(feedId:any) {
    this.getFeedsListCall(feedId)
      .subscribe(data => {
       let responce : any = data;
        this.feeds = responce.body.Item;
        this.setFeedDetails();
      });
  }

  selectCategory(event: any):any {
    this.selectedCategory = event;
  }

  selectDomain(event: any):any {
    this.selectedDomain = event;
  }

  selectTags(event: any):any {
    console.log(event);
  }

  handleKeyEnter(event: any):any {
    if(event) event.preventDefault();
  }

  cancelFeed() {
    this.route.navigateByUrl('/feeds');
  }

  saveFeed() {
    this.enableValidation();
    this.commonService.validateMandatoryFields(this.feedsForm);
    if(!this.feedsForm.valid) {
      return;
    }
    this.buildFeedDetails();
  }

  enableValidation() {
    this.categorytype.setValidators(Validators.compose([Validators.required]));
    this.domain.setValidators(Validators.compose([Validators.required]));
    this.descriptionval.setValidators(Validators.compose([Validators.required]));
    // this.feedlink.setValidators(Validators.compose([Validators.required]));
    // this.tags.setValidators(Validators.compose([Validators.required]));

    this.categorytype.updateValueAndValidity();
    this.domain.updateValueAndValidity();
    this.descriptionval.updateValueAndValidity();
    this.feedlink.updateValueAndValidity();
    // this.tags.updateValueAndValidity();
  }

  buildFeedDetails() {
    this.feeds.category = this.selectedCategory;
    this.feeds.description = this.description;
    this.feeds.contentDetails = this.contentDetails;

    this.feeds.domain = this.selectedDomain;
    this.feeds.link = this.feedLink;
    this.feeds.tags = this.selectedTagIds;

    if (this.feeds.description != undefined && this.feeds.description != null && this.feeds.description != ""){
    let wordCount = this.feeds.description ? this.feeds.description.split(/\s+/) : 0;

      if(wordCount.length > 20){
        this.msgService.error("Description should be less than 20 words")
      return;

      }
    }

    if (this.feeds.contentDetails != undefined && this.feeds.contentDetails != null && this.feeds.contentDetails != ""){
      let wordCount = this.feeds.contentDetails ? this.feeds.contentDetails.split(/\s+/) : 0;
  
        if(wordCount.length > 250){
          this.msgService.error("Content Detail should be less than 250 words")
        return;
  
        }
      }


      if(localStorage.getItem("userId")!= undefined) {
        this.feeds.userId = localStorage.getItem("userId");
      }



//     if (this.feeds.link != undefined && this.feeds.link != null && this.feeds.link != ""){
//  this.http.get('http://api.linkpreview.net/?key=accd5245417245de6140169b9d5ff688&q='+this.feeds.link).subscribe((data: any)=>{
//       console.log(data);

//       let metadata:any = {};
//        metadata.description = data.description;
//        metadata.contentDetails = data.contentDetails;

//        metadata.image = data.image;
//        metadata.title = data.title;
//        metadata.url = data.url;


//       this.feeds.linkMetaData = metadata;
//       this.saveFeedsListCallTrigger();
//     })
//     } else {
      this.saveFeedsListCallTrigger();
    // }
  }

  setFeedDetails() {
    this.feeds.id = this.feedId;
    this.selectedCategory = this.feeds.category;
    this.description = this.feeds.description;
    this.contentDetails = this.feeds.contentDetails;

    this.selectedDomain = this.feeds.domain;
    this.feedLink = this.feeds.link;
    this.selectedTagIds = this.feeds.tags;

    setTimeout(()=>{                          
      this.setTagsForExisting();
  }, 1000);
  }

  setTagsForExisting(){

    if(this.selectedTagIds != undefined && this.selectedTagIds != [] && this.selectedTagIds.length >  0 ){
      this.selectedTags = [];

      for (let j = 0; j < this.selectedTagIds.length; j++) {

          for (let i = 0; i < this.tagList.length; i++) {
            
            if(this.selectedTagIds[j] == this.tagList[i].name){
              this.selectedTags.push(this.tagList[i]);
            }
            
          }
        
      }



    }


  }



  saveFeedsListCallTrigger() {
    let body :any = {};
    body = this.feeds;
    this.http.post<any>('https://blkjn5e2mgn5mkfwckxerfo2xi0cacgn.lambda-url.us-west-1.on.aws/',  body).subscribe(data => {
      let responce : any = data;
      this.route.navigateByUrl('/feeds');
    })
  }

  selectable: boolean = true;
  removable: boolean = true;
  selectedTags: any[] = [];
  
  tagSelected(event: any, dmain: any, input: any): void {
    if(!event || !event.isUserInput) {
      return;
    }
    let isAlreadyAdded: boolean = false;
    if (this.selectedTags.length != 0) {
      for (let index = 0; index < this.selectedTags.length; index++) {
        if (dmain.identity == this.selectedTags[index].identity) {
          isAlreadyAdded = true;
        }
      }

      if (!isAlreadyAdded) {
        this.selectedTags.push(dmain);
        this.selectedTagIds.push(dmain.name);
      }
    } else {
      this.selectedTags.push(dmain);
      this.selectedTagIds.push(dmain.name);
    }
    this.tagList = [];
    this.tagList.push(...this.tagListOrg);
    input.value = '';
  }

  remove(dmain: any): void {
    let isExist: boolean = false;
    let removeIndex = 0;
    if (this.selectedTags.length != 0) {
      for (let index = 0; index < this.selectedTags.length; index++) {
        if (dmain.identity == this.selectedTags[index].identity) {
          isExist = true;
          removeIndex = index;
          this.selectedTagIds.splice(this.selectedTagIds.indexOf(dmain.name), 1);
          break;
        }
      }
      
      if(isExist) {
        this.selectedTags.splice(removeIndex, 1);
      }
    }
  }

  searchTag(event: any, input: any): any {
    if (this.commonService.preventKeyUp(event)) {
      let selctedTagValue = input.value;
      if(!this.commonService.validateText(selctedTagValue)) {
        this.tagList = [];
        this.tagList.push(...this.tagListOrg);
        return;
      }
      this.tagList = this.tagList.filter( val => val.name.toLowerCase().includes(selctedTagValue.toLowerCase()));
    }
  }

  get categorytype():any {
    return this.feedsForm.get('categorytype');
  }

  get domain():any {
    return this.feedsForm.get('domain');
  }

  get descriptionval():any {
    return this.feedsForm.get('descriptionval');
  }

  get contentDetailsval():any{
    return this.feedsForm.get('contentDetailsval');

  }

  get feedlink():any {
    return this.feedsForm.get('feedlink');
  }

  get tags():any {
    return this.feedsForm.get('tags');
  }

}
